import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';

class EditAttributePage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.editAttribute = this.editAttribute.bind(this);

        this.state = {
            required: false,
            type: 'number'
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }

        //console.log(this.props[0].match.params);
        this.setState({
            category: this.props[0].match.params.cid
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('editAttribute', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            if (data.error) {

            } else if (data.successful) {
                this.props[0].history.push(`/categories/${this.props[0].match.params.cid}/attributes`);
            }
        });


        this.props.socketIOClient.on('getAdminAttribute', (data) => {
            this.props.handleLoader(null);

            this.setState({
                ...data
            });
        });



        this.props.socketIOClient.emit('getAdminAttribute', { attribute: this.props[0].match.params.aid });


    }

    editAttribute() {
        this.props.handleLoader(true);

        this.props.socketIOClient.emit("editAttribute", this.state);
    }


    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("getAdminAttribute");
        this.props.socketIOClient.removeAllListeners("editAttribute");

    }

    render() {

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel panel-6">
                    <div className="panel-title">
                        <h1>{this.props.translate('Edit attribute')}</h1>
                        <h6>{this.props.translate('Change fields to edit attribute')}</h6>

                    </div>

                    <div>



                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Name')}</label>
                            <input type="text" value={this.state.name} onChange={(e) => { this.setState({ name: e.target.value, alias: this.props.generateAlias(e.target.value) }) }} />
                        </div>


                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Alias')}</label>
                            <input type="text" value={this.state.alias} onChange={(e) => { this.setState({ alias: e.target.value }) }} />
                        </div>

                        <div className="input-wrap input-wrap-6">
                            <label>{this.props.translate('Type')}</label>
                            <select value={this.state.type} onChange={(e) => { this.setState({ type: e.target.value }) }}>
                                <option value='number'>Number</option>
                                <option value='string'>String</option>
                                <option value='year'>Year</option>
                                <option value='select'>Select</option>
                                <option value='check'>Check</option>
                            </select>
                        </div>

                        <div className="input-wrap input-wrap-3">

                            <label>{this.props.translate('Required')}</label>
                            <Switch className="react-switch"
                                checked={this.state.required}
                                handleColor="white"
                                offColor="rgb(204, 204, 204)"
                                onChange={() => { this.setState({ required: !this.state.required }) }}
                                onColor="rgb(146, 44, 136)"
                                pendingOffColor={undefined}
                                pendingOnColor={undefined}
                                readOnly={undefined}
                                style={undefined}
                            />

                        </div>

                        <div className="input-wrap input-wrap-3">

                            <label>{this.props.translate('Hidden')}</label>
                            <Switch className="react-switch"
                                checked={this.state.hidden}
                                handleColor="white"
                                offColor="rgb(204, 204, 204)"
                                onChange={() => { this.setState({ hidden: !this.state.hidden }) }}
                                onColor="rgb(146, 44, 136)"
                                pendingOffColor={undefined}
                                pendingOnColor={undefined}
                                readOnly={undefined}
                                style={undefined}
                            />

                        </div>

                        {
                            this.state.type === 'select' &&
                            <div className="input-wrap ">
                                <label>{this.props.translate('Values')}</label>
                                <textarea value={this.state.values} onChange={(e) => { this.setState({ values: e.target.value }) }}>

                                </textarea>
                            </div>
                        }

                        <div className="input-wrap">
                            <button className="button" onClick={this.editAttribute}>{this.props.translate('Edit')}</button>
                        </div>




                    </div>
                </div>



            </div>
        );
    }
}

export default PageWithLayout(EditAttributePage);


// WEBPACK FOOTER //
// ./src/views/editAttributePage.js